import { useScreenVariant } from "../../branding/useScreenVariant";
import { ScreenVariant } from "../../branding/selectScreen";
import { BrandScope } from "../../branding/BrandScope";

import SecurityAuthDefault from "./SecurityAuthDefault";
import SecurityAuthNotPortal from "./SecurityAuthNotPortal";
import SecurityAuthBranded from "./SecurityAuthBranded";

function SecurityAuth() {
  const { variant, brand } = useScreenVariant();

  switch (variant) {
    case ScreenVariant.NOT_PORTAL:
      return <SecurityAuthNotPortal />;
    case ScreenVariant.BRANDED:
      return (
        <BrandScope brand={brand}>
          <SecurityAuthBranded />
        </BrandScope>
      );
    // TRADING cai no Default, como no comportamento atual.
    default:
      return <SecurityAuthDefault />;
  }
}

export default SecurityAuth;
